import { Link } from 'react-router-dom';
import SeriesCard from '@/components/feature/SeriesCard';
import { seriesList, categoryMap } from '@/mocks/series';

export default function Explore() {
  const featured = [...seriesList]
    .filter((s) => s.status !== 'coming' || s.id === 'wei-lai')
    .sort((a, b) => b.heat - a.heat)
    .slice(0, 6);

  return (
    <>
      <section className="mx-auto w-full px-4 pb-14 md:px-6 md:pb-20">
        <div className="mx-auto w-full max-w-6xl">
          <div className="flex items-end justify-between gap-4">
            <div>
              <p className="text-sm font-bold tracking-wide text-primary-600">追更进行时</p>
              <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-4xl">正在追更的热门系列</h2>
            </div>
            <Link
              to="/chasing"
              className="hidden items-center whitespace-nowrap rounded-full border border-background-200 px-4 py-2 text-sm font-bold text-foreground-700 transition-colors hover:border-primary-300 hover:text-primary-600 sm:inline-flex"
            >
              进入追更大厅
              <i className="ri-arrow-right-line ml-1"></i>
            </Link>
          </div>

          <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
            {featured.map((s) => (
              <SeriesCard key={s.id} series={s} />
            ))}
          </div>
        </div>
      </section>

      <section className="bg-background-100 py-14 md:py-20">
        <div className="mx-auto w-full px-4 md:px-6">
          <div className="mx-auto w-full max-w-6xl">
            <div className="text-center">
              <p className="text-sm font-bold tracking-wide text-primary-600">吃瓜有门道</p>
              <h2 className="mt-1 font-heading text-2xl text-foreground-950 md:text-4xl">按类型浏览，想追哪场翻哪页</h2>
            </div>

            <div className="mt-9 grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
              {categoryMap.map((c) => {
                const count = seriesList.filter((s) => s.categoryKey === c.key).length;
                return (
                  <Link
                    key={c.key}
                    to={`/chasing?cat=${c.key}`}
                    className="group flex flex-col items-center rounded-2xl border border-background-200 bg-background-50 p-5 text-center transition-all hover:-translate-y-1 hover:border-primary-200"
                  >
                    <span className="flex h-12 w-12 items-center justify-center rounded-2xl bg-gradient-to-br from-primary-100 to-secondary-100 text-xl text-primary-600 transition-colors group-hover:from-primary-500 group-hover:to-secondary-400 group-hover:text-background-50">
                      <i className={c.icon}></i>
                    </span>
                    <h3 className="mt-3 text-sm font-bold text-foreground-950 md:text-base">{c.name}</h3>
                    <p className="mt-1 line-clamp-2 text-xs leading-4 text-foreground-500">{c.desc}</p>
                    <span className="mt-2 whitespace-nowrap text-xs font-medium text-primary-600">{count} 个系列在追</span>
                  </Link>
                );
              })}
            </div>
          </div>
        </div>
      </section>
    </>
  );
}